module.exports = __webpack_public_path__ + "static/historia_en-ba340c968a9c391c3f2c2218c557fe2b.jpg";